import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { LanguageProvider } from "./i18n/LanguageContext";
import { Toaster } from "./components/ui/sonner";
import PasswordGate from "./components/PasswordGate";
import Home from "./pages/Home";

function App() {
  return (
    <PasswordGate>
      <div className="App">
        <LanguageProvider>
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<Home />} />
            </Routes>
          </BrowserRouter>
          <Toaster theme="dark" />
        </LanguageProvider>
      </div>
    </PasswordGate>
  );
}

export default App;
